module.exports = __webpack_public_path__ + "img/big-cloud1.17320b7f.png";